import dayjs from 'dayjs';
import 'dayjs/locale/fr'; // load French locale
import duration from 'dayjs/plugin/duration'; // load duration plugin

dayjs.extend(duration);
dayjs.locale('fr');

export default function formatSeconds(
  inputSeconds: string | undefined,
): string {
  const totalSeconds = Number(inputSeconds);

  if (Number.isNaN(totalSeconds)) {
    return '';
  }
  const d = dayjs.duration(totalSeconds, 'seconds');
  const days = d.days();
  const hours = d.hours();
  const minutes = d.minutes();
  const seconds = d.seconds();

  let result = '';
  if (days > 0) {
    result += days > 1 ? `${days} jours ` : `${days} jour `;
  }
  if (hours > 0) {
    result += hours > 1 ? `${hours} heures ` : `${hours} heure `;
  }
  if (minutes > 0) {
    result += minutes > 1 ? `${minutes} minutes ` : `${minutes} minute `;
  }
  if (seconds > 0 || result === '') {
    result += seconds > 1 ? `${seconds} secondes` : `${seconds} seconde`;
  }
  return result.trim();
}
